export enum MultipartErrorType {
  CancelledByUser = 'cancelledByUser',
  FileUploadError = 'fileUploadError',
}

export enum MultipartErrorMessage {
  CancelledByUser = 'File upload cancelled by user',
  FileUploadError = 'File upload failed. Try again',
}
